import axios from 'axios';
import store from './store';
import moment from 'moment';

const Api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': 'Authorization',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  mode: 'no-cors',
  credentials: true,
  crossdomain: true,
  timeout: 50000,
});

const ApiBlob = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': 'Authorization',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  mode: 'no-cors',
  credentials: true,
  crossdomain: true,
  responseType: 'blob',
});

let apiConfig = {};
Api.interceptors.request.use(
  (config) => {
    apiConfig = config;
    const LocalDataVuex =
      localStorage.getItem('user_dkm') &&
      localStorage.getItem('user_dkm') !== 'undefined'
        ? JSON.parse(localStorage.getItem('user_dkm'))
        : false;

    if (LocalDataVuex && LocalDataVuex.access_token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${(LocalDataVuex &&
          LocalDataVuex.access_token) ||
          ''}`,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ApiBlob.interceptors.request.use(
  (config) => {
    apiConfig = config;
    const LocalDataVuex =
      localStorage.getItem('user_dkm') &&
      localStorage.getItem('user_dkm') !== 'undefined'
        ? JSON.parse(localStorage.getItem('user_dkm'))
        : false;

    if (LocalDataVuex && LocalDataVuex.access_token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${(LocalDataVuex &&
          LocalDataVuex.access_token) ||
          ''}`,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  async (response) => {
    let config = response.config;
    apiConfig = config;

    if (config.url.indexOf('/auth/refreshtoken') !== -1) {
      localStorage.setItem('user_dkm', JSON.stringify(response.data.object));
    } else {
      const LocalDataVuex =
        localStorage.getItem('user_dkm') &&
        localStorage.getItem('user_dkm') !== 'undefined'
          ? JSON.parse(localStorage.getItem('user_dkm'))
          : false;

      if (
        LocalDataVuex &&
        LocalDataVuex.access_token &&
        LocalDataVuex.expired_time &&
        LocalDataVuex.expired_time !== ''
      ) {
        let timeNow = moment(new Date());
        let timeout = moment(LocalDataVuex.expired_time);
        if (timeNow.diff(timeout, 'minutes') > 10) {
          await ApiPostRequest('/auth/refreshtoken');
        }
      }

      return response;
    }
  },
  async (error) => {
    return Promise.reject(error);
  }
);

ApiBlob.interceptors.response.use(
  async (response) => {
    let config = response.config;
    apiConfig = config;

    if (config.url.indexOf('/auth/refreshtoken') !== -1) {
      localStorage.setItem('user_dkm', JSON.stringify(response.data.object));
    } else {
      const LocalDataVuex =
        localStorage.getItem('user_dkm') &&
        localStorage.getItem('user_dkm') !== 'undefined'
          ? JSON.parse(localStorage.getItem('user_dkm'))
          : false;

      if (
        LocalDataVuex &&
        LocalDataVuex.access_token &&
        LocalDataVuex.expired_time &&
        LocalDataVuex.expired_time !== ''
      ) {
        let timeNow = moment(new Date());
        let timeout = moment(LocalDataVuex.expired_time);
        if (timeNow.diff(timeout, 'minutes') > 10) {
          await ApiPostRequest('/auth/refreshtoken');
        }
      }

      return response;
    }
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export function showErrorNotification(error) {
  let message =
    (error.response && error.response.data && error.response.data.message) ||
    error.message;

  let error_data =
    (error.response && error.response.data && error.response.data.errors) ||
    false;

  // kalau ada error unautorize clear localstorage
  if (
    message === 'Unauthorized' &&
    apiConfig &&
    apiConfig.url.indexOf('/auth/refreshtoken') === -1
  ) {
    localStorage.removeItem('user_dkm');
    window.location.href = '/adm/login';
    return false;
  } else {
    if (message === 'Unauthorized') {
      return false;
    } else {
      store.dispatch('notification/showNotif', {
        message:
          message && message !== ''
            ? message.indexOf('timeout of') !== -1
              ? 'Periksa Kembali Koneksi Internet Anda'
              : message
            : 'Tidak Dapat Mengakses Data',
        type: 'error',
      });

      return {
        message:
          message && message !== ''
            ? message.indexOf('timeout of') !== -1
              ? 'Periksa Kembali Koneksi Internet Anda'
              : message
            : 'Tidak Dapat Mengakses Data',
        error_data,
      };
    }
  }
}

export function ApiBlobGetRequest(url, data = {}) {
  return ApiBlob.get(url, {
    params: data,
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function ApiGetRequest(url, data = {}) {
  return Api.get(url, {
    params: data,
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function ApiPostMultipart(url, data = {}) {
  return Api.post(url, data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function ApiGetUploadFile(url, data = {}, callbackUpload = () => {}) {
  return Api.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (event) => callbackUpload(event),
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export const ApiPostRequest = (url, data = {}) => {
  return Api.post(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};

export const ApiPutRequest = (url, data = {}) => {
  return Api.put(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};

export const ApiDeleteRequest = (url, data = {}) => {
  return Api.delete(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};
